import moment from "moment";
import DropDown from "../../component/DropDown";
import {
  Months,
  BagianConstant,
  constantYear,
  kepalaShiftTimOne,
  kepalaShiftTimTwo,
  bulan,
  tahun,
} from "../../constant";
import { useDashboard } from "../dashboard/useDashboard";
import React, { useEffect, useRef } from "react";
import AccordionAbsensi from "../../component/AccordionAbsensi/AccordionAbsensi";
import { monthDefaultFormat } from "../../util/formatDate";
// CSS lama tetap di-import supaya halaman lain / AccordionAbsensi yang
// masih memakai class-nya tidak berubah.
import "./Absensi.css";
import PopUpComponent from "../../component/PopUpComponent/PopUpComponent";
import DeleteIcon from "../../asset/delete_icon.png";
import Select from "react-select";
import SearchLogo from "../../asset/search-icon.png";

const STATUS_COLOR_FALLBACK = {
  hadir: "#3ebd81",
  izin: "#f5a623",
  sakit: "#5b8def",
  alpha: "#e74c3c",
  libur: "#8e44ad",
};

const STATUS_LABEL_SHORT = {
  hadir: "H",
  izin: "I",
  sakit: "S",
  alpha: "A",
  libur: "L",
};

const STATUS_LABEL_FULL = {
  hadir: "Hadir (Absen Reguler)",
  izin: "Izin",
  sakit: "Sakit",
  alpha: "Alpha",
  libur: "Libur",
};

const getStatusColor = (status) => STATUS_COLOR_FALLBACK[status] || "#9e9e9e";
const getStatusLabelShort = (status) => STATUS_LABEL_SHORT[status] || "?";
const getStatusLabelFull = (status) => STATUS_LABEL_FULL[status] || status;

const LEGEND_ITEMS = [
  { status: "hadir", label: "Hadir (Absen Reguler)" },
  { status: "izin", label: "Izin" },
  { status: "sakit", label: "Sakit" },
  { status: "alpha", label: "Alpha" },
  { status: "libur", label: "Libur" },
];

const TABS = [
  { key: "Absensi", label: "Absensi" },
  { key: "AddNewAbsensi", label: "Add New Absensi" },
  { key: "HariLibur", label: "Hari Libur" },
  { key: "TabelLibur", label: "Tabel Libur" },
];

// Penanda entry libur dari backend.
// Sesuaikan kalau field-nya beda (cek console.log(data.listTgl)).
const isLiburEntry = (item) =>
  item?.status?.toString().toLowerCase() === "libur" || item?.isLibur === true;

// Gabung listTgl per tanggal. Entry libur SELALU menang,
// jadi tidak ditimpa oleh entry hadir ("H") di tanggal yang sama.
const mergeListTgl = (listTgl = []) => {
  const map = new Map();
  listTgl.forEach((item) => {
    const existing = map.get(item.date);
    if (!existing || (isLiburEntry(item) && !isLiburEntry(existing))) {
      map.set(item.date, { ...item });
    }
  });
  return map;
};

const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 38,
    borderRadius: 8,
    borderColor: state.isFocused ? "#0e5d5a" : "#c5d3d2",
    boxShadow: state.isFocused ? "0 0 0 3px rgba(14,93,90,.18)" : "none",
    "&:hover": { borderColor: "#0e5d5a" },
  }),
};

const Absensi = () => {
  const {
    jsonTim,
    valueSearch,
    setValueSearch,
    searchFeature,
    editParams,
    setFilterMonth,
    setFilterRole,
    handleExportExcel,
    editOTParams,
    setFilterDate,
    addNewAbsent,
    setClockIn,
    setDateIn,
    setClockOut,
    setDateOut,
    setKtpNumber,
    isFilter,
    setIsFilter,
    setFilterDateFrom,
    setFilterDateUntil,
    handleFilterUntil,
    setFilterYear,
    filterYear,
    filterKepala,
    setFilterKepala,
    handleExportRange,
    popUp,
    setPopUp,
    handleExportJamLebih,
    setFile,
    handleImportHariLibur,
    popUpImport,
    setPopUpImport,
    dateHariLibur,
    setDateHariLibur,
    subMenuAbsensi,
    setSubMenuAbsensi,
    dataHariLibur,
    handleDeleteOrang,
    dataUserEdit,
    setFileImportJam,
    handleImportJam,
    reFormat,
    operatorPick,
    setOperatorPick,
    handleKirimSatuan,
    dateTempListTanggal,
    findSameShift,
    filterShift,
    setFilterShift,
    filterMonthTable,
    setFilterMonthTable,
    filterYearTable,
    setFilterYearTable,
    handleResetFilterTable,
    valueSearchTable,
    setValueSearchTable,
    dataTempPoSearch,
    popUpFilterTable,
    setPopUpFilterTable,
    filterRange,
    filterFrom,
    setFilterFrom,
    filterUntil,
    setFilterUntil,
    findSamePersonRange,
    isFilterRange,
    dateTempListTanggalRange,
    dataTempPoSearchRange,
    multipleSortRange,
  } = useDashboard();

  const d = new Date();
  const getMonth = d.getMonth();

  useEffect(() => {
    setFilterMonth(monthDefaultFormat[getMonth]);
  }, []);

  let dataTemp = searchFeature(valueSearch);

  const rowRef = useRef(null);

  const multipleSortTanggalRange =
    dateTempListTanggalRange &&
    dateTempListTanggalRange.sort((a, b) => {
      if (a.date < b.date) return -1;
      if (a.date > b.date) return 1;

      return 0;
    });

  const multipleSortDataRange =
    dataTempPoSearchRange &&
    dataTempPoSearchRange.sort((a, b) => {
      if (a.shift < b.shift) return -1;
      if (a.shift > b.shift) return 1;

      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;

      return 0;
    });

  const pickData = isFilterRange ? multipleSortDataRange : dataTempPoSearch;
  const pickTanggal = isFilterRange
    ? multipleSortTanggalRange
    : dateTempListTanggal;

  // Scroll ke kolom tanggal hari ini. Sebelumnya dipanggil di body render
  // (jalan di setiap ketikan/render); sekarang hanya saat tab / daftar tanggal berubah.
  useEffect(() => {
    if (subMenuAbsensi === "TabelLibur" && rowRef.current) {
      rowRef.current.scrollIntoView({
        behavior: "smooth",
        inline: "start",
        block: "nearest",
      });
    }
  }, [subMenuAbsensi, pickTanggal && pickTanggal.length]);

  const getDateToday = moment().utcOffset("+0700").format("DD");

  return (
    <div className="abs-page">
      <div className="abs-card">
        {/* ===== Pop up: sukses import (tampilan asli) ===== */}
        {popUpImport ? (
          <div className="popup_container" style={{ zIndex: 1000 }}>
            <div className="popup_wrapper">
              <p style={{ lineHeight: "20px", fontSize: "16px" }}>
                Selamat! Data kamu sudah di Update
              </p>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <button
                  className="reset_button"
                  style={{ background: "red" }}
                  onClick={() => setPopUpImport(false)}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}

        {/* ===== Pop up peringatan whitelist (komponen bersama, tidak diubah) ===== */}
        {popUp && (
          <PopUpComponent>
            <p>
              <label className="warning-popup-absen">&#9888; </label>
              Mohon Selalu meng-Update{" "}
              <b className="warning-popup-absen">WHITELIST HARI MINGGU</b> dan
              selalu cek Data sebelum{" "}
              <b className="warning-popup-absen">LIBURAN!</b>
            </p>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <button className="cancel_button" onClick={() => setPopUp(false)}>
                Tutup
              </button>
            </div>
          </PopUpComponent>
        )}

        {/* ===== Pop up: filter range tab Absensi (tampilan asli) ===== */}
        {isFilter ? (
          <div className="popup_container" style={{ zIndex: 1000 }}>
            <div className="popup_wrapper">
              <div style={{ display: "flex", justifyContent: "space-around" }}>
                <div>
                  <p>Dari</p>
                  <input
                    style={{ height: "27px", width: "112px" }}
                    type="date"
                    onChange={(e) => setFilterDateFrom(e.target.value)}
                  />
                </div>
                <div>
                  <p>Sampai</p>
                  <input
                    style={{ height: "27px", width: "112px" }}
                    type="date"
                    onChange={(e) => setFilterDateUntil(e.target.value)}
                  />
                </div>
              </div>

              <button
                className="button-cari-absen"
                onClick={() => handleFilterUntil()}
              >
                Cari
              </button>
              <button
                style={{ marginRight: "6px", background: "green" }}
                className="button-cari-absen"
                onClick={() => handleExportRange()}
              >
                Export
              </button>
              <button
                style={{ marginRight: "6px", background: "green" }}
                className="button-cari-absen"
                onClick={() => handleExportJamLebih()}
              >
                Jam Lebih
              </button>
            </div>
          </div>
        ) : (
          ""
        )}

        {/* ===== Pop up: filter range tab Tabel Libur (tampilan asli) ===== */}
        {popUpFilterTable ? (
          <div className="popup_container" style={{ zIndex: 1000 }}>
            <div className="popup_wrapper">
              <div style={{ display: "flex", justifyContent: "space-around" }}>
                <div>
                  <p>Dari</p>
                  <input
                    style={{ height: "27px", width: "112px" }}
                    type="date"
                    value={filterFrom}
                    onChange={(e) => setFilterFrom(e.target.value)}
                  />
                </div>
                <div>
                  <p>Sampai</p>
                  <input
                    style={{ height: "27px", width: "112px" }}
                    type="date"
                    value={filterUntil}
                    onChange={(e) => setFilterUntil(e.target.value)}
                  />
                </div>
              </div>

              <button
                className="button-cari-absen"
                onClick={() => filterRange()}
              >
                Cari
              </button>
            </div>
          </div>
        ) : (
          ""
        )}

        {/* ===== Tab ===== */}
        <div className="abs-tabs" role="tablist">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              type="button"
              role="tab"
              className="abs-tab"
              aria-selected={subMenuAbsensi === tab.key}
              onClick={() => setSubMenuAbsensi(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* ===================== TAB: ABSENSI ===================== */}
        {subMenuAbsensi === "Absensi" ? (
          <>
            <div className="abs-toolbar abs-toolbar--end abs-section">
              <input
                className="abs-file"
                type="file"
                accept=".xls,.xlsx"
                onChange={(e) => setFileImportJam(e.target.files[0])}
              />
              <button
                className="abs-btn abs-btn--primary"
                onClick={() => handleImportJam()}
              >
                Import Jam Kerja
              </button>
            </div>

            <div className="abs-toolbar abs-section">
              <div className="abs-search">
                <img src={SearchLogo} alt="" />
                <input
                  className="abs-input abs-input--search"
                  type="text"
                  placeholder="Cari nama"
                  aria-label="Cari nama"
                  onChange={(e) => setValueSearch(e.target.value)}
                />
              </div>
              <button
                type="button"
                className="abs-btn abs-btn--secondary"
                onClick={() => setIsFilter(true)}
              >
                Filter Range
              </button>
              <input
                className="abs-input"
                type="date"
                aria-label="Filter tanggal"
                onChange={(e) => setFilterDate(e.target.value)}
              />
              <DropDown
                className="abs-select"
                dataOption={BagianConstant}
                setFilter={setFilterRole}
                placeHolder="Pilih Bagian"
              />
              <DropDown
                className="abs-select"
                dataOption={Months}
                setFilter={setFilterMonth}
                placeHolder="Pilih Bulan"
              />
              <DropDown
                className="abs-select"
                dataOption={constantYear}
                setFilter={setFilterYear}
                value={filterYear}
                placeHolder="Pilih Tahun"
              />
              <DropDown
                className="abs-select"
                dataOption={
                  jsonTim.tim === 1 ? kepalaShiftTimOne : kepalaShiftTimTwo
                }
                setFilter={setFilterKepala}
                value={filterKepala}
                placeHolder="Pilih Kepala"
              />
              <button
                type="button"
                className="abs-btn abs-btn--primary"
                onClick={() => handleExportExcel()}
              >
                Export
              </button>
            </div>

            <div style={{ width: "0", minWidth: "100%", overflow: "auto" }}>
              <table className="table_dashboard absensi-table mobile-font-size-10">
                <tr className="absensi-table__head">
                  <th>No.</th>
                  <th>Nama</th>
                  <th>Absen</th>
                  <th>Lembur</th>
                  <th>Jam Lebih</th>
                </tr>
                {dataTemp &&
                  dataTemp.map((data, index) => {
                    const sortedAbsent =
                      data &&
                      data.absent.sort(function (a, b) {
                        let dateA = new Date(a.clockIn.day),
                          dateB = new Date(b.clockIn.day);
                        return dateB - dateA;
                      });
                    const sortedOverTime =
                      data &&
                      data.overTimeAbsent.sort(function (a, b) {
                        let dateA = new Date(a.clockIn),
                          dateB = new Date(b.clockIn);
                        return dateB - dateA;
                      });
                    data &&
                      data.absent.forEach(function () {
                        editParams.push(false);
                      });
                    data &&
                      data.overTimeAbsent.forEach(function () {
                        editOTParams.push(false);
                      });
                    return (
                      <AccordionAbsensi
                        key={data.id}
                        data={data}
                        sortedAbsent={sortedAbsent}
                        sortedOverTime={sortedOverTime}
                        index={index}
                      />
                    );
                  })}
              </table>
            </div>
          </>
        ) : subMenuAbsensi === "AddNewAbsensi" ? (
          /* ===================== TAB: ADD NEW ABSENSI ===================== */
          <div className="abs-form">
            <div className="abs-field">
              <label htmlFor="abs-date-in">Tanggal Masuk</label>
              <input
                id="abs-date-in"
                className="abs-input"
                type="date"
                onChange={(e) => setDateIn(e.target.value)}
              />
            </div>
            <div className="abs-field">
              <label htmlFor="abs-date-out">Tanggal Keluar</label>
              <input
                id="abs-date-out"
                className="abs-input"
                type="date"
                onChange={(e) => setDateOut(e.target.value)}
              />
            </div>
            <div className="abs-field">
              <label htmlFor="abs-clock-in">Jam Masuk</label>
              <input
                id="abs-clock-in"
                className="abs-input"
                type="time"
                onChange={(e) => setClockIn(e.target.value)}
              />
            </div>
            <div className="abs-field">
              <label htmlFor="abs-clock-out">Jam Keluar</label>
              <input
                id="abs-clock-out"
                className="abs-input"
                type="time"
                onChange={(e) => setClockOut(e.target.value)}
              />
            </div>
            <div className="abs-field">
              <label htmlFor="abs-ktp">No. KTP</label>
              <input
                id="abs-ktp"
                className="abs-input"
                type="number"
                onChange={(e) => setKtpNumber(e.target.value)}
              />
            </div>
            <div className="abs-form-actions">
              <button
                type="button"
                className="abs-btn abs-btn--primary"
                onClick={() => addNewAbsent()}
              >
                Kirim
              </button>
            </div>
          </div>
        ) : subMenuAbsensi === "HariLibur" ? (
          /* ===================== TAB: HARI LIBUR ===================== */
          <>
            <div className="abs-toolbar abs-toolbar--between">
              <input
                className="abs-input"
                type="date"
                aria-label="Tanggal libur"
                value={dateHariLibur}
                onChange={(e) => setDateHariLibur(e.target.value)}
              />
              <div className="abs-toolbar">
                <div className="abs-react-select">
                  <Select
                    placeholder="Pilih Operator"
                    options={reFormat}
                    value={operatorPick || ""}
                    onChange={setOperatorPick}
                    styles={selectStyles}
                  />
                </div>
                <button
                  type="button"
                  className="abs-btn abs-btn--primary"
                  onClick={() => handleKirimSatuan()}
                >
                  Kirim
                </button>
              </div>
              <div className="abs-toolbar">
                <input
                  className="abs-file"
                  type="file"
                  accept=".xls,.xlsx"
                  onChange={(e) => setFile(e.target.files[0])}
                />
                <button
                  type="button"
                  className="abs-btn abs-btn--secondary"
                  onClick={() => handleImportHariLibur()}
                >
                  Import
                </button>
              </div>
            </div>

            <div className="abs-table-wrap">
              <table className="abs-table">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>No. KTP</th>
                    <th>Nama</th>
                    <th>Bagian</th>
                    <th>Tgl Libur</th>
                    <th>Shift</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {dataHariLibur &&
                    dataHariLibur.map((obj, index) => {
                      let find =
                        dataUserEdit &&
                        dataUserEdit.find((i) => i.id === obj.id);

                      return (
                        <tr
                          className={index % 2 === 1 ? "is-alt" : ""}
                          key={index}
                        >
                          <td className="abs-center">{index + 1}.</td>
                          <td>{obj.id}</td>
                          <td>{find && find.name}</td>
                          <td>{obj.bagian}</td>
                          <td>{obj.tgl}</td>
                          <td>{obj.shift}</td>
                          <td className="abs-center">
                            <button
                              type="button"
                              className="abs-icon-btn"
                              aria-label="Hapus"
                              onClick={() => handleDeleteOrang(obj.formId)}
                            >
                              <img src={DeleteIcon} alt="" />
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </>
        ) : (
          /* ===================== TAB: TABEL LIBUR ===================== */
          <>
            <div className="abs-toolbar abs-toolbar--between">
              <div className="abs-toolbar">
                <div className="abs-search">
                  <img src={SearchLogo} alt="" />
                  <input
                    className="abs-input abs-input--search"
                    type="text"
                    placeholder="Cari nama"
                    aria-label="Cari nama"
                    value={valueSearchTable}
                    onChange={(e) => setValueSearchTable(e.target.value)}
                  />
                </div>
                <select
                  className="abs-select"
                  aria-label="Shift"
                  value={filterShift}
                  onChange={(e) => setFilterShift(e.target.value)}
                >
                  <option disabled>Pilih Shift</option>
                  {findSameShift &&
                    findSameShift.map((ele) => (
                      <option key={ele.shift} value={ele.shift}>
                        {ele.shift}
                      </option>
                    ))}
                </select>
                <select
                  className="abs-select"
                  aria-label="Bulan"
                  value={filterMonthTable}
                  onChange={(e) => setFilterMonthTable(e.target.value)}
                >
                  <option disabled>Pilih Bulan</option>
                  {bulan.map((e) => (
                    <option key={e.value} value={e.value}>
                      {e.name}
                    </option>
                  ))}
                </select>
                <select
                  className="abs-select"
                  aria-label="Tahun"
                  value={filterYearTable}
                  onChange={(e) => setFilterYearTable(e.target.value)}
                >
                  <option disabled>Pilih Tahun</option>
                  {tahun.map((e) => (
                    <option key={e} value={e}>
                      {e}
                    </option>
                  ))}
                </select>
                <button
                  type="button"
                  className="abs-btn abs-btn--ghost"
                  onClick={() => handleResetFilterTable()}
                >
                  Reset
                </button>
              </div>
              <button
                type="button"
                className="abs-btn abs-btn--secondary"
                onClick={() => setPopUpFilterTable(true)}
              >
                Filter Range
              </button>
            </div>

            <div className="abs-legend">
              {LEGEND_ITEMS.map((item) => (
                <span key={item.status} className="abs-legend-item">
                  <span
                    className="abs-swatch"
                    style={{ background: getStatusColor(item.status) }}
                  />
                  {item.label}
                </span>
              ))}
            </div>

            <div className="abs-grid-wrap">
              <table className="abs-grid">
                <thead>
                  <tr>
                    <th className="abs-th abs-sticky abs-col-no">No.</th>
                    <th className="abs-th abs-sticky abs-col-shift">Shift</th>
                    <th className="abs-th abs-sticky abs-col-name">Nama</th>
                    {pickTanggal &&
                      pickTanggal.map((ele) => {
                        const isSunday = moment(ele.date).day() === 0;
                        const isToday = ele.tanggal === getDateToday;

                        return (
                          <th
                            key={ele.date}
                            ref={isToday ? rowRef : null}
                            className={
                              "abs-th abs-th-day" +
                              (isToday
                                ? " is-today"
                                : isSunday
                                ? " is-sunday"
                                : "")
                            }
                          >
                            {ele.tanggal}
                          </th>
                        );
                      })}
                  </tr>
                </thead>
                <tbody>
                  {pickData &&
                    pickData.map((data, index) => {
                      // Gabung per tanggal SEKALI per baris (entry libur diprioritaskan)
                      const mergedTgl = mergeListTgl(data.listTgl);

                      return (
                        <tr
                          key={index}
                          className={index % 2 === 1 ? "is-alt" : ""}
                        >
                          <td className="abs-td abs-sticky abs-col-no">
                            {index + 1}.
                          </td>
                          <td className="abs-td abs-sticky abs-col-shift">
                            {data.shift}
                          </td>
                          <td
                            className="abs-td abs-sticky abs-col-name"
                            title={data.name}
                          >
                            {data.name}
                          </td>
                          {pickTanggal &&
                            pickTanggal.map((ele) => {
                              const foundObject = mergedTgl.get(ele.date);
                              const status = foundObject
                                ? isLiburEntry(foundObject)
                                  ? "libur"
                                  : foundObject.status
                                : null;

                              return (
                                <td
                                  key={ele.date}
                                  className="abs-td abs-cell"
                                  title={
                                    foundObject
                                      ? getStatusLabelFull(status)
                                      : undefined
                                  }
                                >
                                  {foundObject && (
                                    <span
                                      className="abs-chip"
                                      style={{
                                        // libur: selalu pakai warna libur,
                                        // abaikan color dari backend
                                        background:
                                          status === "libur"
                                            ? getStatusColor("libur")
                                            : foundObject.color ||
                                              getStatusColor(status),
                                      }}
                                    >
                                      {getStatusLabelShort(status)}
                                    </span>
                                  )}
                                </td>
                              );
                            })}
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
export default Absensi;
